import Component from '../../../../../pages/vpp/features/other-sellers-new-items/index';

export default Component;
